import { PhoneAndroid, Call, Email } from '@material-ui/icons'
import EmailItem from './EmailItem'
import PhoneItem from './PhoneItem'
import SMSItem from './SMSItem'
import FormItem from './FormItem'
import { FileTable } from 'mdi-material-ui'

export default {
  call: { icon: Call, label: 'PHONE', component: PhoneItem },
  sms: { icon: PhoneAndroid, label: 'TEXT', component: SMSItem },
  email: { icon: Email, label: 'EMAIL', component: EmailItem },
  formsub: { icon: FileTable, label: 'FORM', component: FormItem },
}
